import { motion } from "framer-motion";
import { useState } from "react";

/* ─── Premium SVG icon set ───────────────────────────────────────── */
const OilFilterIcon = () => (
  <svg viewBox="0 0 56 56" fill="none" className="w-11 h-11">
    <rect x="16" y="4" width="24" height="48" rx="7" stroke="#E31837" strokeWidth="1.8" fill="url(#of-bg)"/>
    <rect x="22" y="10" width="12" height="2.5" rx="1.25" fill="#E31837" opacity=".7"/>
    <rect x="22" y="16" width="12" height="2.5" rx="1.25" fill="#E31837" opacity=".55"/>
    <rect x="22" y="22" width="12" height="2.5" rx="1.25" fill="#E31837" opacity=".4"/>
    <rect x="22" y="28" width="12" height="2.5" rx="1.25" fill="#E31837" opacity=".28"/>
    <rect x="22" y="34" width="12" height="2.5" rx="1.25" fill="#E31837" opacity=".18"/>
    <path d="M24 44 C24 41.8 26 40 28 40 C30 40 32 41.8 32 44" stroke="#E31837" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
    <line x1="28" y1="44" x2="28" y2="48" stroke="#E31837" strokeWidth="2" strokeLinecap="round"/>
    <rect x="24" y="1" width="8" height="5" rx="2" fill="#E31837" opacity=".35" stroke="#E31837" strokeWidth="1.2"/>
    <defs>
      <linearGradient id="of-bg" x1="16" y1="4" x2="40" y2="52" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFF1F2"/>
        <stop offset="1" stopColor="#FFE4E6"/>
      </linearGradient>
    </defs>
  </svg>
);

const AirFilterIcon = () => (
  <svg viewBox="0 0 56 56" fill="none" className="w-11 h-11">
    <rect x="6" y="14" width="44" height="28" rx="6" stroke="#3B82F6" strokeWidth="1.8" fill="url(#af-bg)"/>
    {[0,1,2,3,4,5].map(i => (
      <rect key={i} x={12 + i*7} y="20" width="3.5" height="16" rx="1.75" fill="#3B82F6" opacity={0.55 - i*0.06}/>
    ))}
    {/* Air flow arrows */}
    <path d="M3 24 L8 28 L3 32" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity=".5"/>
    <path d="M53 24 L48 28 L53 32" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity=".5"/>
    <defs>
      <linearGradient id="af-bg" x1="6" y1="14" x2="50" y2="42" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EFF6FF"/>
        <stop offset="1" stopColor="#DBEAFE"/>
      </linearGradient>
    </defs>
  </svg>
);

const BrakePadIcon = () => (
  <svg viewBox="0 0 56 56" fill="none" className="w-11 h-11">
    {/* Brake disc */}
    <circle cx="28" cy="28" r="22" stroke="#F59E0B" strokeWidth="1.8" fill="url(#bp-bg)" strokeDasharray="6 4"/>
    <circle cx="28" cy="28" r="14" stroke="#F59E0B" strokeWidth="1.5" fill="none"/>
    <circle cx="28" cy="28" r="4" fill="#F59E0B" opacity=".4"/>
    {/* Caliper */}
    <path d="M6 22 L6 34 Q6 38 10 38 L18 38 Q22 38 22 34 L22 22 Q22 18 18 18 L10 18 Q6 18 6 22Z"
      fill="url(#caliper-bg)" stroke="#F59E0B" strokeWidth="1.6"/>
    <rect x="9" y="22" width="10" height="12" rx="2" fill="#F59E0B" opacity=".25"/>
    <defs>
      <radialGradient id="bp-bg" cx="50%" cy="50%" r="50%">
        <stop stopColor="#FFFBEB"/>
        <stop offset="1" stopColor="#FEF3C7"/>
      </radialGradient>
      <linearGradient id="caliper-bg" x1="6" y1="18" x2="22" y2="38" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FEF9EE"/>
        <stop offset="1" stopColor="#FEF3C7"/>
      </linearGradient>
    </defs>
  </svg>
);

const SparkPlugIcon = () => (
  <svg viewBox="0 0 56 56" fill="none" className="w-11 h-11">
    {/* Hex body */}
    <path d="M28 4 L38 10 L38 22 L28 28 L18 22 L18 10 Z" fill="url(#sp-bg)" stroke="#8B5CF6" strokeWidth="1.8"/>
    {/* Thread lines */}
    <line x1="18" y1="28" x2="22" y2="28" stroke="#8B5CF6" strokeWidth="1.3" opacity=".5"/>
    <rect x="22" y="28" width="12" height="18" rx="3" fill="url(#sp-bg)" stroke="#8B5CF6" strokeWidth="1.6"/>
    {[0,1,2,3].map(i => (
      <line key={i} x1="22" y1={31+i*4} x2="34" y2={31+i*4} stroke="#8B5CF6" strokeWidth="1" opacity=".3"/>
    ))}
    {/* Electrode */}
    <line x1="28" y1="46" x2="28" y2="52" stroke="#8B5CF6" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M25 50 L28 46 L31 50" fill="none" stroke="#8B5CF6" strokeWidth="1.6" strokeLinejoin="round"/>
    {/* Spark */}
    <path d="M32 10 L27 19 L31 19 L26 28" stroke="#FCD34D" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
    <defs>
      <linearGradient id="sp-bg" x1="18" y1="4" x2="38" y2="28" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F5F3FF"/>
        <stop offset="1" stopColor="#EDE9FE"/>
      </linearGradient>
    </defs>
  </svg>
);

const WiperIcon = () => (
  <svg viewBox="0 0 56 56" fill="none" className="w-11 h-11">
    {/* Wiper arc */}
    <path d="M8 46 Q28 10 48 46" stroke="#06B6D4" strokeWidth="2" fill="none" strokeLinecap="round"/>
    <path d="M10 46 Q28 14 46 46" stroke="#06B6D4" strokeWidth="7" strokeLinecap="round" fill="none" opacity=".15"/>
    {/* Blade */}
    <rect x="5" y="43" width="46" height="7" rx="3.5" fill="url(#wp-bg)" stroke="#06B6D4" strokeWidth="1.6"/>
    {/* Arm */}
    <line x1="28" y1="43" x2="28" y2="24" stroke="#06B6D4" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="28" cy="22" r="4" fill="url(#wp-bg)" stroke="#06B6D4" strokeWidth="1.8"/>
    <circle cx="28" cy="22" r="1.8" fill="#06B6D4" opacity=".5"/>
    {/* Rain drops */}
    <circle cx="16" cy="20" r="1.5" fill="#06B6D4" opacity=".35"/>
    <circle cx="24" cy="12" r="1.2" fill="#06B6D4" opacity=".25"/>
    <circle cx="36" cy="16" r="1.4" fill="#06B6D4" opacity=".3"/>
    <defs>
      <linearGradient id="wp-bg" x1="5" y1="43" x2="51" y2="50" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ECFEFF"/>
        <stop offset="1" stopColor="#CFFAFE"/>
      </linearGradient>
    </defs>
  </svg>
);

const HeadlightIcon = () => (
  <svg viewBox="0 0 56 56" fill="none" className="w-11 h-11">
    {/* Bulb glass */}
    <path d="M28 6 C20 6 14 12 14 20 C14 26 17 30 21 33 L21 40 L35 40 L35 33 C39 30 42 26 42 20 C42 12 36 6 28 6Z"
      fill="url(#hl-bg)" stroke="#F59E0B" strokeWidth="1.8"/>
    {/* Filament */}
    <path d="M23 22 L23 18 L25 18 L25 24 L27 24 L27 18 L29 18 L29 24 L31 24 L31 18 L33 18 L33 22"
      stroke="#F59E0B" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Base */}
    <rect x="21" y="40" width="14" height="4" rx="2" fill="#F59E0B" opacity=".35" stroke="#F59E0B" strokeWidth="1.4"/>
    <rect x="23" y="44" width="10" height="4" rx="2" fill="#F59E0B" opacity=".25" stroke="#F59E0B" strokeWidth="1.2"/>
    {/* Rays */}
    <line x1="28" y1="3" x2="28" y2="0" stroke="#FDE68A" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="42" y1="8" x2="44.5" y2="5.5" stroke="#FDE68A" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="46" y1="20" x2="50" y2="20" stroke="#FDE68A" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="14" y1="8" x2="11.5" y2="5.5" stroke="#FDE68A" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="10" y1="20" x2="6" y2="20" stroke="#FDE68A" strokeWidth="1.8" strokeLinecap="round"/>
    <defs>
      <radialGradient id="hl-bg" cx="50%" cy="40%" r="60%">
        <stop stopColor="#FEFCE8"/>
        <stop offset="1" stopColor="#FEF3C7"/>
      </radialGradient>
    </defs>
  </svg>
);

/* ─── Product data ───────────────────────────────────────────────── */
const products = [
  {
    id: 1, name: "Engine Oil Filter", price: 100,
    description: "High-quality filtration keeps your engine oil clean and your engine running at peak efficiency.",
    tag: "Best Seller", accent: "#E31837", accentLight: "#FFF1F2",
    img: "/images/oil-filter.jpg",
    Icon: OilFilterIcon,
  },
  {
    id: 2, name: "Car Air Filter", price: 150,
    description: "Maximises airflow into the combustion chamber for better power, mileage and engine longevity.",
    tag: null, accent: "#3B82F6", accentLight: "#EFF6FF",
    img: "/images/air-filter.jpg",
    Icon: AirFilterIcon,
  },
  {
    id: 3, name: "Brake Pads Set", price: 300,
    description: "Ceramic-compound pads with ultra-low dust and consistent stopping power in all conditions.",
    tag: "Premium", accent: "#F59E0B", accentLight: "#FFFBEB",
    img: "/images/brake-pads.jpg",
    Icon: BrakePadIcon,
  },
  {
    id: 4, name: "Spark Plug Set", price: 200,
    description: "Iridium-tip plugs for faster starts, cleaner combustion and improved fuel economy.",
    tag: null, accent: "#8B5CF6", accentLight: "#F5F3FF",
    img: "/images/spark-plugs.jpg",
    Icon: SparkPlugIcon,
  },
  {
    id: 5, name: "Car Wiper Blades", price: 250,
    description: "Aero-flat beam blades for streak-free clarity in rain, dust and all weather extremes.",
    tag: null, accent: "#06B6D4", accentLight: "#ECFEFF",
    img: "/images/wiper-blades.jpg",
    Icon: WiperIcon,
  },
  {
    id: 6, name: "Headlight Bulb", price: 500,
    description: "H4 / H7 halogen & LED options — 120% brighter road illumination, 2× longer lifespan.",
    tag: "Top Rated", accent: "#F59E0B", accentLight: "#FFFBEB",
    img: "/images/headlight-bulb.jpg",
    Icon: HeadlightIcon,
  },
];

const goContact = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

/* ─── Card ───────────────────────────────────────────────────────── */
function ProductCard({ p, i }) {
  const [done, setDone] = useState(false);
  const enquire = () => {
    setDone(true);
    setTimeout(() => setDone(false), 2200);
    goContact();
  };

  return (
    <motion.article
      initial={{ opacity: 0, y: 44 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group relative bg-white rounded-[1.6rem] overflow-hidden border border-gray-100/80
                 shadow-[0_2px_20px_rgba(0,0,0,0.06)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.13)]
                 transition-all duration-400 hover:-translate-y-2 flex flex-col"
    >
      {/* ── Image ── */}
      <div className="relative h-52 overflow-hidden">
        <img
          src={p.img} alt={p.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          onError={e => (e.target.style.display = "none")}
          loading="lazy"
        />
        {/* gradient fade */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" />

        {/* Badge */}
        {p.tag && (
          <span className="absolute top-3.5 left-3.5 bg-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-lg"
            style={{ color: p.accent }}>
            {p.tag}
          </span>
        )}

        {/* Floating icon */}
        <div className="absolute bottom-3.5 right-3.5 rounded-2xl p-2.5 shadow-xl border border-white/60"
          style={{ backgroundColor: p.accentLight }}>
          <p.Icon />
        </div>
      </div>

      {/* ── Body ── */}
      <div className="p-6 flex flex-col flex-1">
        {/* Thin accent line */}
        <div className="w-8 h-0.5 rounded-full mb-4" style={{ backgroundColor: p.accent }} />

        <h3 className="text-gray-900 text-[1.05rem] mb-2 leading-snug group-hover:text-red-600 transition-colors"
          style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700 }}>
          {p.name}
        </h3>
        <p className="text-gray-400 text-sm leading-relaxed flex-1 mb-5">{p.description}</p>

        <div className="flex items-end justify-between">
          <div>
            <p className="text-gray-300 text-[11px] uppercase tracking-widest mb-0.5">Starting at</p>
            <p className="text-[1.7rem] leading-none" style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, color: p.accent }}>
              ${p.price}
            </p>
          </div>
          <button onClick={enquire}
            className={`text-[0.82rem] font-bold px-5 py-2.5 rounded-xl transition-all duration-200 ${
              done
                ? "bg-green-500 text-white scale-95"
                : "text-white hover:opacity-90 hover:scale-105 shadow-lg"
            }`}
            style={done ? {} : { backgroundColor: p.accent, boxShadow: `0 8px 20px ${p.accent}40` }}>
            {done ? "✓ Noted!" : "Enquire →"}
          </button>
        </div>
      </div>
    </motion.article>
  );
}

/* ─── Section ────────────────────────────────────────────────────── */
export default function Products() {
  return (
    <section id="products" className="py-28 bg-[#FAFAF9]" aria-label="Products">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14"
        >
          <div>
            <span className="chip mb-4">Our Catalogue</span>
            <h2 className="text-4xl md:text-5xl text-gray-900 tracking-tight leading-tight"
              style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800 }}>
              Popular <span className="text-red-600">Products</span>
            </h2>
          </div>
          <p className="text-gray-400 max-w-xs text-[0.95rem] leading-relaxed md:text-right">
            OEM-standard parts at prices you'll love, shipped anywhere in the USA within 24 hours.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {products.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mt-14 text-center"
        >
          <p className="text-gray-400 mb-5 text-sm">Don't see what you're looking for?</p>
          <button onClick={goContact}
            className="group inline-flex items-center gap-2.5 border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white font-bold px-8 py-3.5 rounded-2xl transition-all duration-300 text-sm">
            Request a Custom Part
            <svg className="w-4 h-4 transition-transform group-hover:translate-x-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </button>
        </motion.div>
      </div>
    </section>
  );
}
